import ClientForm from "./ClientForm";
import { AutoPagePaperLayout } from "pages/Layouts/AutoPagePaperLayout";
import { PageBreadcrumbs, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export function ClientNew() {
  return (
    <AutoPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Logistics" }, { label: "Clients", path: "/logistics/clients" }]} />
      <PageTitle>Add New Company</PageTitle>

      <ClientForm />
    </AutoPagePaperLayout>
  );
}
